// Stay-within-reach preference: labels and plain-English wording (no travel-time maths).
export const REL = { home: "Home", family: "Family", friends: "Friends", partner: "Partner", another_place: "Another place" };
export const MODE = { public_transport: "Public transport", car: "Car", flights: "Flights" };
export const IMP = { essential: "Essential", preferred: "Preferred", exploring: "Just exploring" };
export const FREQ = { weekly: "Every week", fortnightly: "Every fortnight", monthly: "Once a month", termly: "Once a term", few_times_a_year: "A few times a year" };
export const HOURS = [1, 2, 3, 4, 6];
export const blank = () => ({ relationship: "home", location: "", max_hours: 3, modes: ["public_transport"], importance: "preferred", international: false, visit_frequency: null });

export function anchorLabel(a) {
  return `${REL[a.relationship]} (${a.location})`;
}

export function describeAnchor(a) {
  const hrs = `${a.max_hours} hour${a.max_hours === 1 ? "" : "s"}`;
  const modes = a.modes.map((m) => MODE[m].toLowerCase()).join(" or ");
  return `Within ${hrs} of ${anchorLabel(a)} by ${modes}${a.modes.includes("flights") ? " (door to door)" : ""} · ${IMP[a.importance]}`
    + (a.international && a.visit_frequency ? ` · visiting ${FREQ[a.visit_frequency].toLowerCase()}` : "");
}

